import React, { useState, useEffect } from "react";
import NavBar from "../Common/NavBar";
import { useListarElementos } from "../Hooks/CRUDHooks";
import { GeocercaURL, GeocercaxPaisxTipoURL, GeocercaxTipoSURL, TipoSURL, paisesURL } from "../API/apiurls";
import { Form, Col } from "react-bootstrap";
import { RiFilter3Line, RiImage2Line, RiVolumeUpLine, RiPlayCircleLine } from "react-icons/ri";
import axios from "axios";
import { GeocercaxPaisURL } from "./../API/apiurls";

export function GaleriaDeCercas() {
  const [cercas, setCercas] = useState([]);
  const [paises, setPaises] = useState([]);
  const [tipoS, setTipoS] = useState([]);
  const [filtroPais, setFiltroPais] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState(""); 

  useListarElementos(GeocercaURL, cercas, setCercas);
  useListarElementos(paisesURL, paises, setPaises);
  useListarElementos(TipoSURL, tipoS, setTipoS);

  useEffect(() => {
    const fetchData = async () => {
      if (filtroPais && !filtroCategoria) {
        setCercas("");
        try {
          const response = await axios.get(`${GeocercaxPaisURL}${filtroPais}`);
          setCercas(response.data);
        } catch (error) {
          console.error(
            "Error al cargar datos:",
            error,
            `${GeocercaxPaisURL}${filtroPais}`
          );
        }
      } else if (!filtroPais && filtroCategoria) {
        setCercas("");
        try {
          const response = await axios.get(`${GeocercaxTipoSURL}${filtroCategoria}`);
          setCercas(response.data);
        } catch (error) {
          console.error(
            "Error al cargar datos:",
            error,
            `${GeocercaxPaisURL}${filtroCategoria}`
          );
        }
      } else if (filtroPais && filtroCategoria) {
        setCercas("");
        try {
          const response = await axios.get(`${GeocercaxPaisxTipoURL}${filtroPais}/${filtroCategoria}`);
          setCercas(response.data);
        } catch (error) {
          console.error(
            "Error al cargar datos:",
            error,
            `${GeocercaxPaisURL}${filtroPais}`
          );
        }
      } else {
        const response = await axios.get(`${GeocercaURL}`);
        setCercas(response.data);
      }
    };

    fetchData();
  }, [filtroPais, filtroCategoria]);

  const categorias = [
    "Todas",
    "Señales Reglamentarias",
    "Señales Informativas",
    "Señales de Prevención",
  ];

  useEffect(() => {}, [filtroCategoria]);

  return (
    <div className="galeria-page">
      <NavBar />
      <section className="galeria-header">
        <div className="galeria-header-copy">
          <div className="galeria-eyebrow">
            <RiImage2Line /> Galeria visual
          </div>
          <h1 className="galeria-title">Galería de Cercas</h1>
          <p className="galeria-subtitle">
            Explora las geocercas por país y categoría con una vista más clara y adaptable.
          </p>
        </div>

        <div className="galeria-summary-card">
          <span className="galeria-summary-label">Resultados visibles</span>
          <strong className="galeria-summary-value">{Array.isArray(cercas) ? cercas.length : 0}</strong>
        </div>
      </section>

      <section className="galeria-filters">
        <div className="galeria-filters-title">
          <RiFilter3Line /> Filtros
        </div>

        <div className="galeria-filters-grid">
          <Form.Group as={Col} controlId="filtroPais" className="galeria-filter-group">
            <Form.Label>Filtrar por País</Form.Label>
            <Form.Control
              as="select"
              value={filtroPais}
              onChange={(e) => setFiltroPais(e.target.value)}
            >
              <option value="">Todos los países</option>
              {paises.map((pais) => (
                <option key={pais.id} value={pais.id}>
                  {pais.nombre}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} controlId="filtroCategoria" className="galeria-filter-group">
            <Form.Label>Filtrar por Categoría</Form.Label>
            <Form.Control
              as="select"
              value={filtroCategoria}
              onChange={(e) => setFiltroCategoria(e.target.value)}
            >
              <option value={""}>Todas</option>
              {tipoS.map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  Señales {categoria.nombre}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>
      </section>

      <section className="galeria-grid">
        {cercas &&
          cercas.map((cerca) => (
            <article key={cerca.id} className="galeria-card">
              <div className="galeria-card-media">
                <img
                  src={cerca.urlImagen}
                  alt={cerca.nombre || "Imagen de cerca"}
                  className="galeria-card-image"
                />
              </div>

              <div className="galeria-card-body">
                <h2 className="galeria-card-title">{cerca.nombre}</h2>
                <p className="galeria-card-detail">{cerca.detalle && cerca.detalle}</p>

                <div className="galeria-card-meta">
                  <span className="galeria-card-badge">
                    <RiVolumeUpLine /> Codigo: {cerca.codsonido}
                  </span>
                </div>
              </div>

              <div className="galeria-card-audio">
                <div className="galeria-audio-label">
                  <RiPlayCircleLine /> Reproducir sonido
                </div>
                {cerca.urlSonido ? (
                  <audio controls preload="none" className="galeria-audio-player">
                    <source src={cerca.urlSonido} />
                    Tu navegador no soporta audio.
                  </audio>
                ) : (
                  <div className="galeria-audio-empty">Sin audio disponible</div>
                )}
              </div>
            </article>
          ))}

        {Array.isArray(cercas) && cercas.length === 0 && (
          <div className="galeria-empty-state">
            <h3>No se encontraron cercas</h3>
            <p>Ajusta los filtros para explorar otras combinaciones.</p>
          </div>
        )}
      </section>
    </div>
  );
}
